import { Route, Routes } from "react-router-dom";
import { SnpApiProvider } from "./context/SnpApiContext";
import SnpChatWidget from "./ui/SnpChatWidget";
import ChatAdminUi from "./ui/ChatAdminUi";
import './css/SnpChatApp.css';
import { useEffect, useRef, useState } from "react";
import { isEmptyData, printChatDebugLog } from "./utils/SnpChatUtils";
import { InternalAddRemoveChannel, ToneType } from "./utils/SnpChatConstant";
import SnpChatAdminWidget from "./ui/SnpChatAdminWidget";
import PhotoView from "./ui/PhotoView";
import ChatSound from "./context/ChatSound";
export { useSnpChatPublicApi } from './public-snp-sdk';


const SnpChatApp = ({ use_admin = false, onAdminMounted = null }) => {

    const onAdminMountedRef = useRef(onAdminMounted);

    const [selectedChat, setSelectedChat] = useState(null);
    const [toast, setToast] = useState(null);
    const [receivedChats, setReceivedChats] = useState([]);
    const [runningChats, setRunningChats] = useState([]);
    const [pendingChats, setPendingChats] = useState([]);
    const [chatAdminHead, setChatAdminHead] = useState(false);
    const [refreshChat, setRefreshChat] = useState(false);
    const [notificationSound, setNotificationSound] = useState({});
    const [chatSocketHandlers, setChatSocketHandlers] = useState(new Map());
    const [mShowImageView, setShowImageView] = useState({ show: false, url: "" });
    const [whoStopped, setWhoStopped] = useState(0);

    useEffect(() => {
        onAdminMountedRef.current = onAdminMounted;
    }, [onAdminMounted]);


    useEffect(() => {
        printChatDebugLog("ChatContext:Chat App Loaded ... ");
        if (onAdminMountedRef.current) {
            onAdminMountedRef.current();
        }
    }, []);

    const EnableSound = (mAudioSrc) => {
        setNotificationSound({
            message: '',
            show: true,
            audioSrc: mAudioSrc
        });
        // Hide the notification after 5 seconds
        setTimeout(() => {
            setNotificationSound({
                message: '',
                show: false,
                audioSrc: "",
            });
        }, 2500);
    };

    const initiateSoundNotification = (toneType) => {
        if (toneType === ToneType.New_Chat_Receive) {
            EnableSound("/message_pop.mp3");
        } else if (toneType === ToneType.New_Message_Receive) {
            EnableSound("/chat.wav");
        } else if (toneType === ToneType.Error) {
            EnableSound("/error.mp3");
        }
    };

    const externalNotification = (msg) => {
        var options = {
            body: msg,
            icon: 'https://www.snpnextgen.com/static/media/snp_logo-1.5f6346a2.png?auto=compress&cs=tinysrgb&dpr=1&w=500',
            dir: 'ltr',
        };
        if (Notification.permission === 'default') {
            Notification.requestPermission().then(permission => {
                if (permission !== 'granted') {
                    console.error('Notification permission not granted');
                }
            });
        }
        //Show notication and pass data to service worker
        if (navigator.serviceWorker) {
            navigator.serviceWorker.ready.then(registration => {
                registration.showNotification("Chat Notification", options);
            });
        }
    }

    const handleCustomToastFunc = (tag, msg, isError, toneType = ToneType.No_Sound) => {
        printChatDebugLog("ChatContext:handleCustomToastFunc", tag, msg, isError, toneType);
        // if (customToastFunc !== null) {
        //     customToastFunc(msg, isError);
        // } else {

        // }
        if (isEmptyData(msg)) {
            printChatDebugLog("ChatContext:handleCustomToastFunc isEmptyData", tag, msg);
            msg = "Received new notification ... ";
        }
        if (isError) {
            setToast({ type: 'error', message: msg });
        } else {
            setToast({ type: 'success', message: msg });
        }
        externalNotification(msg);
        initiateSoundNotification(toneType);
    };

    const updateChats = (obj) => {
        setRunningChats((prevRunning) => {
            const foundInRunning = prevRunning.some(c => c.sessionId === obj.sessionId);
            if (foundInRunning) {
                // Replace in running
                return prevRunning.map(c =>
                    c.sessionId === obj.sessionId ? obj : c
                );
            }
            return prevRunning; // No change if not found
        });

        setReceivedChats((prevReceived) => {
            const foundInReceived = prevReceived.some(c => c.sessionId === obj.sessionId);
            if (foundInReceived) {
                // Replace in received
                return prevReceived.map(c =>
                    c.sessionId === obj.sessionId ? obj : c
                );
            }
            return prevReceived; // No change if not found
        });
    };


    const handleAddRemoveItemCallback = (channel, obj) => {
        printChatDebugLog("ChatContext:removeItemCallback", `channel: ${channel}`, "obj: ", obj);
        if (channel === InternalAddRemoveChannel.Receive_Chat_Add) {
            setReceivedChats((prev) => {
                if (prev.length === 0) {
                    return [obj];
                } else {
                    return [...prev, obj];
                }
            });
        } else if (channel === InternalAddRemoveChannel.Receive_Chat_Remove) {
            setReceivedChats((prev) => prev.filter(c => c.sessionId !== obj));
        } else if (channel === InternalAddRemoveChannel.Receive_Chat_Full) {
            setReceivedChats(obj);
        } else if (channel === InternalAddRemoveChannel.Receive_Chat_Empty) {
            setReceivedChats([]);
        } else if (channel === InternalAddRemoveChannel.Running_Chat_Add) {
            setRunningChats((prev) => [...prev, obj]);
        } else if (channel === InternalAddRemoveChannel.Running_Chat_Remove) {
            setRunningChats((prev) => prev.filter(c => c.sessionId !== obj));
        } else if (channel === InternalAddRemoveChannel.Running_Chat_Full) {
            setRunningChats(obj);
        } else if (channel === InternalAddRemoveChannel.Running_Chat_Empty) {
            setRunningChats([]);
        } else if (channel === InternalAddRemoveChannel.Pending_Chat_Add) {
            setPendingChats((prev) => [...prev, obj]);
        } else if (channel === InternalAddRemoveChannel.Pending_Chat_Remove) {
            setPendingChats((prev) => prev.filter(c => c.sessionId !== obj));
        } else if (channel === InternalAddRemoveChannel.Pending_Chat_Full) {
            setPendingChats(obj);
        } else if (channel === InternalAddRemoveChannel.Pending_Chat_Empty) {
            setPendingChats([]);
        } else if (channel === InternalAddRemoveChannel.Running_Recive_Chat_Replace) {
            updateChats(obj);
        }
    };


    const removeChatItemFromList = (tag, chatSessionId, onlyReceive = false) => {
        const index = receivedChats.length === 0 ? -1 : receivedChats.findIndex(singleValue => singleValue.sessionId === chatSessionId);
        if (index > -1) {
            const chat = receivedChats[index];
            printChatDebugLog(`ChatContext:removeChatItemFromList:${tag}`, chat);
            handleAddRemoveItemCallback(InternalAddRemoveChannel.Receive_Chat_Remove, chatSessionId);
            handleCustomToastFunc("removeChatItemFromList1", `Session ${chat.messageFrom} removed`, false);
        } else if (!onlyReceive) {
            const indexRunning =
                runningChats.length === 0 ? -1 : runningChats.findIndex(singleValue => singleValue.sessionId === chatSessionId);
            if (indexRunning > -1) {
                const chat = runningChats[indexRunning];
                printChatDebugLog(`ChatContext:removeChatItemFromList:${tag}`, chat);
                handleAddRemoveItemCallback(InternalAddRemoveChannel.Running_Chat_Remove, chatSessionId);
                handleCustomToastFunc("removeChatItemFromList1", `Session ${chat.messageFrom} removed`, false);
            }
        }

    };


    const handleSelectedChat = (selecetdChatObj) => {
        printChatDebugLog("ChatContext:handleSelectedChat", selecetdChatObj);
        setSelectedChat(selecetdChatObj);
    };

    const handleSetChatAdminHead = (chatAdminHeadObj) => {
        printChatDebugLog("ChatContext:handleSetChatAdminHead", chatAdminHeadObj);
        setChatAdminHead(chatAdminHeadObj);
    };

    // const handleSetChatSocketHandler = (sessionId, mHandler, isAdd) => {
    //     printChatDebugLog("ChatContext:handleSetChatSocketHandler", sessionId);
    //     if (isAdd) {
    //         chatSocketHandlers.set(sessionId, mHandler);
    //     } else {
    //         chatSocketHandlers.delete(sessionId);
    //     }
    //     setChatSocketHandlers(chatSocketHandlers);
    // };

    const handleSetChatSocketHandler = (sessionId, mHandler, isAdd) => {
        printChatDebugLog("ChatContext:handleSetChatSocketHandler", sessionId);

        setChatSocketHandlers((prev) => {
            const newMap = new Map();
            if (isAdd) {
                newMap.set(sessionId, mHandler);
            }
            return newMap;
        });
    };

    const handleCloseChat = () => {
        printChatDebugLog("ChatContext:handleCloseChat", selectedChat);
        if (selectedChat) {
            handleSetChatSocketHandler(selectedChat?.sessionId, null, false);
            setSelectedChat(null);
            setChatAdminHead(false);
        }
    };

    const handleDismiss = () => {
        setShowImageView({ show: false, url: "" });
    };

    const handleRefreshChat = (refreshChatObj) => {
        printChatDebugLog("ChatContext:handleRefreshChat", refreshChatObj);
        setRefreshChat(refreshChatObj);
    };

    const handleWhoStopped = (whoStoppedObj) => {
        printChatDebugLog("ChatContext:handleWhoStopped", whoStoppedObj);
        setWhoStopped(whoStoppedObj)
    };


    return (
        <SnpApiProvider>
            {
                mShowImageView.show &&
                <PhotoView imageUrl={mShowImageView.url} onDismiss={handleDismiss} />
            }
            <ChatSound play={notificationSound.show} audioSrc={notificationSound.audioSrc} />
            {use_admin ? (
                <>
                    <Routes>
                        <Route path="/chat-admin" element={<ChatAdminUi
                            handleCustomToastFunc={handleCustomToastFunc}
                            receivedChats={receivedChats}
                            runningChats={runningChats}
                            pendingChats={pendingChats}
                            setAddRemoveItemCallback={handleAddRemoveItemCallback}
                            selectedChat={selectedChat}
                            setSelectedChat={handleSelectedChat}
                            closeChat={handleCloseChat}
                            refreshChat={refreshChat}
                            setRefreshChat={handleRefreshChat}
                            setChatAdminHead={setChatAdminHead}
                            setWhoStopped={handleWhoStopped}
                        />} />
                    </Routes>
                    <SnpChatAdminWidget
                        handleCustomToastFunc={handleCustomToastFunc}
                        selectedChat={selectedChat}
                        toast={toast}
                        setToast={setToast}
                        removeChatItemFromList={removeChatItemFromList}
                        handleAddRemoveItemCallback={handleAddRemoveItemCallback}
                        chatSocketHandlers={chatSocketHandlers}
                        setChatSocketHandlers={handleSetChatSocketHandler}
                        chatAdminHead={chatAdminHead}
                        setChatAdminHead={handleSetChatAdminHead}
                        setShowImageView={setShowImageView}
                        setRefreshChat={setRefreshChat}
                        closeChat={() => {
                            setSelectedChat(null);
                            setChatAdminHead(false);
                            setWhoStopped(0);
                        }}
                        initiateSoundNotification={initiateSoundNotification}
                        whoStopped={whoStopped}
                        setWhoStopped={handleWhoStopped}
                    />
                </>
            ) : (
                <SnpChatWidget
                    sessionId={""}
                    mUserDetails={null}
                    viaAdmin={false}
                    registerSocketHandler={() => { }}
                    unregisterSocketHandler={() => { }}
                    setChatAdminHead={() => { }}
                    showImageView={setShowImageView}
                    setRefreshChat={() => { }}
                    whoStopped={whoStopped}
                    setWhoStopped={handleWhoStopped}
                    initiateSoundNotification={initiateSoundNotification}
                />
            )}
        </SnpApiProvider>
    );

}

export default SnpChatApp;